module.exports = __webpack_public_path__ + "static/media/N1.1cf91ef8.png";